import { AzurePermission, JsonData, MenuItem } from 'models';
import * as routes from 'router/Routes';

export const REGEXP = {
  email:
    /^[-!#$%&'*+/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/,
  allCapLetters: /^[A-Z]+$/,
  uuid: /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i,
};

const baseTransition = {
  visibility: {
    delay: 0.2,
  },
  height: {
    duration: 0.2,
  },
};

export const foldableVariants = {
  open: {
    height: 'auto',
    visibility: 'visible',
    opacity: 1,
    transition: {
      ...baseTransition,
      opacity: {
        delay: 0.2,
        duration: 0.1,
      },
    },
  },
  closed: {
    height: 0,
    visibility: 'hidden',
    opacity: 0,
    transition: {
      ...baseTransition,
      opacity: {
        duration: 0.2,
      },
    },
  },
};

export const emptyRoles: AzurePermission[] = [];

export const diamRolePermissions: JsonData = {
  isGlobalAdmin: 'GlobalAdmin',
  isGlobalReadonlyAdmin: 'GlobalReadonlyAdmin',
  isAdmin: 'Admin',
  isReadOnlyAdmin: 'ReadonlyAdmin',
  canViewStatistics: 'ViewStatistics',
};

export const connectivityMenu: MenuItem[] = [
  {
    id: 'connectivity',
    intl: 'sidebar.connectivity',
    link: routes.DEVICES,
  },
];

export const softwareMenu: MenuItem[] = [
  {
    id: 'software',
    intl: 'sidebar.softwares',
    link: routes.SOFTWARES,
  },
];

export const rolloutMenu: MenuItem[] = [
  {
    id: 'rollout',
    intl: 'sidebar.rollouts',
    link: routes.ROLLOUTS,
  },
];

export const lwm2mMenu: MenuItem[] = [
  {
    id: 'lwm2m',
    intl: 'sidebar.lwm2m',
    link: routes.LWM2M,
  },
];

export const husqiotbusMenu: MenuItem[] = [
  {
    id: 'husqiotbus',
    intl: 'sidebar.husqiotbus',
    link: routes.HUSQIOTBUS,
  },
];
